import { render } from "./Form.vue?vue&type=template&id=19d07b6b&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=19d07b6b&scoped=true&lang=css"
import "./Form.vue?vue&type=style&index=1&id=19d07b6b&lang=css"
script.render = render
script.__scopeId = "data-v-19d07b6b"

export default script